import { render, staticRenderFns } from "./H5Page_AISZ.vue?vue&type=template&id=3f8fb1ff&"
import script from "./H5Page_AISZ.vue?vue&type=script&lang=js&"
export * from "./H5Page_AISZ.vue?vue&type=script&lang=js&"
import style0 from "./H5Page_AISZ.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports